<template>
  <div
    :style="{
      backgroundImage: zoomIsActive ? 'none' : bg_img,
      backgroundSize: bgsize,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      maxWidth: max_width,
      position: 'relative',
    }"
    class="media"
    :class="{ 'is-circled': circled }"
  >
    <a @click.prevent="isImageModalActive = true" href="#">
      <img
        v-if="zoomIsActive === false"
        :width="img_width"
        :height="img_height"
        :style="{ width: img_width, height: img_height }"
        src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      />
    </a>

    <b-modal v-model="isImageModalActive"> 
      <p class="image is-4by3">
        <img :src="full" />
      </p>
    </b-modal>

  </div>
</template>

<script>

import AppMappers from "@/store/app-global-mappers";

export default {
  name: "SimpleMediaImg",
  props: {
    size: {
      type: String,
      default: "800x600",
    },
    mobile_size: {
      type: String,
      default: "600x300",
    },
    img: String,
    full: String,
    maxwidth: Number,
    bgsize: {
      type: String,
      default: "contain",
    },
    circled: {
      type: Boolean,
      default: false,
    },
    height_auto: {
      type: Boolean,
      default: false,
    },
    zoomable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [AppMappers],  
  data() {
    return {
      width: 800,
      height: 600,
      mobile_width: 600,
      mobile_height: 250,
      zoomIsActive: false,
      isImageModalActive: false,
    };
  },

  created() {
    let sizes, mobile_sizes;

    sizes = this.size.split("x");
    this.width = sizes[0];
    this.height = sizes[1];

    mobile_sizes = this.mobile_size.split("x");
    this.mobile_width = mobile_sizes[0];
    this.mobile_height = mobile_sizes[1];
  },

  computed: {
    bg_img() {
      if (this.img) return `url('${this.img}')`;

      return null;
    },

    max_width() {
      if (this.maxwidth) return `${this.maxwidth}px`;

      return null;
    },

    img_width() {
      if (this.device.isMobileOnly) {
        return `${this.mobile_width}px`;
      }

      return `${this.width}px`;
    },

    img_height() {
      if (this.height_auto) {
        return "auto";
      }

      if (this.device.isMobileOnly) {
        return `${this.mobile_height}px`;
      }
      return `${this.height}px`;
    },
  },
};
</script>

<style lang="scss">
.media {
  &.is-circled {
    border-radius: 50%;
  }
}
</style>